import { useQuery } from '@tanstack/react-query';
import type { CriticalsDelta } from '@seo/types';
import { apiGet } from '@/lib/api';

/**
 * `<CriticalsDeltaCard>` data source — signed delta of open-critical count
 * between the two most recent completed audits for the project.
 */
export function useAuditCriticalsDelta(projectId: string | undefined) {
  return useQuery({
    queryKey: ['audit-criticals-delta', projectId],
    enabled: !!projectId,
    queryFn: () =>
      apiGet<CriticalsDelta>(
        `/v1/projects/${encodeURIComponent(projectId!)}/audit-criticals-delta`,
      ),
    staleTime: 30_000,
    placeholderData: (prev) => prev,
  });
}
